module.exports = __webpack_public_path__ + "static/1-b303b9276e8981d700db7ba5f768844a.jpeg";